import { combineReducers, configureStore } from '@reduxjs/toolkit';
// eslint-disable-next-line
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import viewerReducer from 'entities/viewer';
import organizationsReducer from 'entities/organizations';
import { isDevEnv } from 'shared/get-env';
import { edpApiV1 } from 'app/services/edpApiV1';
import { viewerModel } from 'entities/viewer';
import vacationsReducer from 'entities/vacations';
import absenceReducer from 'entities/absence';
import consultationsReducer from 'entities/consultations';
import reportsReducer from 'entities/reports';
import referencesReducer from 'entities/references';
import employeesReducer from 'entities/employees';
import vacationsScheduleReducer from 'entities/vacationsSchedule';
import uiReducer from 'entities/ui';
import newsReducer from 'entities/news';
import substitutionsReducer from 'entities/substitutions';
import rvdReducer from 'entities/rvd';
import overtimeReducer from 'entities/overtime';
import faqReducer from 'entities/faq';
import searchReducer from 'entities/search';
import dayOffReducer from 'entities/dayOff';
import divisionsReducer from 'entities/divisions';
import { supervisorReducer } from 'entities/supervisor';
import { clientCookies } from '../shared/lib';

const entities = combineReducers({
  viewer: viewerReducer,
  organizations: organizationsReducer,
  vacations: vacationsReducer,
  consultations: consultationsReducer,
  reports: reportsReducer,
  references: referencesReducer,
  employees: employeesReducer,
  vacationsSchedule: vacationsScheduleReducer,
  absence: absenceReducer,
  substitutions: substitutionsReducer,
  news: newsReducer,
  rvd: rvdReducer,
  overtime: overtimeReducer,
  faq: faqReducer,
  search: searchReducer,
  dayOff: dayOffReducer,
  divisions: divisionsReducer,
  supervisor: supervisorReducer,
});

const getStore = () => {
  const store = configureStore({
    reducer: {
      [edpApiV1.reducerPath]: edpApiV1.reducer,
      entities,
      ui: uiReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(edpApiV1.middleware),
    devTools: isDevEnv,
  });

  const refreshToken = clientCookies.get('refreshToken');
  if (refreshToken) {
    const { dispatch } = store;
    const token = clientCookies.get('token') || null;
    dispatch(viewerModel.credentials.actions.setCredentials({ token, refreshToken }));
    dispatch(viewerModel.credentials.actions.setIsAuth(true));
  }

  return store;
};

export const store = getStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
